// extracted by mini-css-extract-plugin
module.exports = {"root":"OrderTransactionsList_root__2zihQ","noDataContainer":"OrderTransactionsList_noDataContainer__29Rcl"};